import { Injectable } from '@angular/core';
import { SagepayPiService } from '@df/module-sagepay';
import { Subject } from 'rxjs/internal/Subject';

export const SAGEPAY_PI_SAVED_CARD_STATUS_DISPLAY_SUBMITTED = 'sagepay-pi.saved-card.submitted';

@Injectable({
    providedIn: 'root'
})
export class SagepayPiServiceDecorator extends SagepayPiService {
    dataUpdate = new Subject<void>();

    private _selectedCardType?: string;

    private codes: {
        [id: string]: string;
    } = {};

    getCode(id: string): string | undefined {
        return this.codes[id];
    }

    setCode(id: string, code: string): void {
        this.codes[id] = code;
        this.dataUpdate.next();
    }

    get selectedCardType(): string | undefined {
        return this._selectedCardType;
    }

    set selectedCardType(type: string | undefined) {
        this._selectedCardType = type;
        this.dataUpdate.next();
    }

    getCardTitle(type: string) {
        switch (type) {
            case 'vi':
            case 'visa':
                return 'Visa';
            case 'amex':
            case 'ae':
                return 'American Express';
            case 'mc':
            case 'mastercard':
                return 'MasterCard';
            default:
                return 'Credit Card';
        }
    }
}
